var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.fallbackImage,"alt":_vm.alt,"width":_vm.width,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }